import { call, put, takeEvery } from "redux-saga/effects";
import { actions, actionTypes} from "../redux/actions";
import httpClientService from "../../../helpers/apiHelper";
import Config from "../../../helpers/Config";


function* requestMessageDetail(payload) {
  const domin = Config.get("API_HOST");
  const paramaterStr = payload.payload.paramaterStr;
  const token = payload.payload.token;
  // const token = 'tmp'
  const messageData  = yield call(httpClientService,'get', `${domin}/order/service/${paramaterStr}`, token, {paramaterStr: paramaterStr} );
  console.log('messageData = ', messageData);
  if(messageData.result === false){

  }

  if(!messageData.data){
    yield put(actions.LoadMessageDetailFailed(messageData.msg));
  }else{
    yield put(actions.LoadMessageDetailSuccess(messageData.data[0]));
  }
}

export function* watchRequestMessageDetail() {
  yield takeEvery(actionTypes.RequestMessageDetail, requestMessageDetail);
}

